import React from 'react';
import { motion } from 'framer-motion';
export function SocialProof() {
  return <section className="bg-white py-16 px-4" data-id="element-134">
      <div className="max-w-4xl mx-auto text-center" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-navy text-white p-8 md:p-12 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-136">
          {/* Decorative quote marks */}
          <div className="absolute -top-6 -left-2 text-[120px] font-heading text-white/10 leading-none select-none" data-id="element-137">
            "
          </div>

          <h2 className="font-heading font-bold text-2xl md:text-3xl mb-6 relative z-10 leading-relaxed" data-id="element-138">
            En solo{' '}
            <span className="text-orange text-4xl md:text-5xl mx-2" data-id="element-139">
              7 días
            </span>
            , la mayoría de los usuarios reportan que pueden volver a subir
            escaleras y manejar su vehículo sin el "pinchazo" eléctrico
            constante.
          </h2>

          <p className="font-body text-lg md:text-xl text-white/80 font-medium relative z-10" data-id="element-140">
            No es magia, es liberar la presión mecánica que nunca debió estar
            ahí.
          </p>
        </motion.div>
      </div>
    </section>;
}